"use strict";
import { iconSizes } from "ui/src/theme";
import {
  OnchainItemListOptionType
} from "components/lists/items/types";
import { ENSAddressOptionItem } from "components/lists/items/wallets/ENSAddressOptionItem";
import { UnitagOptionItem } from "components/lists/items/wallets/UnitagOptionItem";
import { WalletBaseOptionItem } from "components/lists/items/wallets/WalletBaseOptionItem";
import { AccountIcon } from "features/accounts/AccountIcon";
import { DisplayNameType } from "features/accounts/types";
import { useOnchainDisplayName } from "features/accounts/useOnchainDisplayName";
import { useAvatar } from "features/address/avatar";
import { ENS_SUFFIX } from "features/ens/constants";
export function WalletByAddressOptionItem({
  walletByAddressOption,
  onPress
}) {
  const { address } = walletByAddressOption;
  const { avatar } = useAvatar(address);
  const displayName = useOnchainDisplayName(address);
  if (displayName?.type === DisplayNameType.Unitag) {
    const unitagOption = {
      type: OnchainItemListOptionType.Unitag,
      address,
      unitag: displayName.name
    };
    return <UnitagOptionItem unitagOption={unitagOption} onPress={onPress} />;
  } else if (displayName?.type === DisplayNameType.ENS) {
    const ensAddressOption = {
      type: OnchainItemListOptionType.ENSAddress,
      address,
      ensName: displayName.name,
      isRawName: !displayName.name.endsWith(ENS_SUFFIX)
      // Ensure raw name is used for subdomains only
    };
    return <ENSAddressOptionItem ensAddressOption={ensAddressOption} onPress={onPress} />;
  }
  return <WalletBaseOptionItem
    option={walletByAddressOption}
    image={<AccountIcon address={address} avatarUri={avatar} size={iconSizes.icon40} />}
    title={displayName?.name ?? ""}
    onPress={onPress}
  />;
}
